<ngx-smart-modal #myModal1 identifier="myModal1">
   <h2 class="modalError">Please login and subscribe to access this content.</h2>
   <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
 </ngx-smart-modal>
<!-- <!-- <ngx-smart-modal #myModal2 identifier="myModal2">
   <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
   <button class="modalErrorButton" (click)="myModal2.close(); refresh()" >Refresh Now</button>
 </ngx-smart-modal> --><div class="loadingBox" *ngIf="!loaded">
   <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
  </div>
 <div *ngIf="loaded">
<app-header ></app-header>
<div id="wrapper">
<app-sidebar></app-sidebar>
<div id="content-wrapper">
<div class="container-fluid upload-details">
    <div class="row">
       <div class="col-lg-12">
          <div class="main-title">
             <h6  i18n="@@Update Account Info | Update Account Info Title">Update Account Info</h6>
          </div>
       </div>
    </div>
    <form>
       <div class="row">
          <div class="col-sm-6">
             <div class="form-group">
                <label i18n="@@Name | Edit Account Name Label" class="control-label">Name </label>
                <input (keyup)="onNameKeyUp($event)" class="form-control border-form-control" value="{{profileData.name}}" placeholder="{{profileData.name}}" type="text">
             </div>
          </div>
          <div class="col-sm-6">
             <div class="form-group">
                <label  i18n="@@Email | Edit Account Email Label" class="control-label">Email </label>
                <input (keyup)="onEmailKeyUp($event)" class="form-control border-form-control" value="{{profileData.email}}" placeholder="{{profileData.email}}" type="text">
             </div>
          </div>
          <div class="col-sm-6">
          <div class="form-group">
            <label>Change Timezone</label>
            <select class="form-control" (change)="updateTimezone($event)">
                            <option disabled selected value> {{timezone}} </option>
                            <option value="Etc/GMT+12">Etc/GMT+12</option>
                            <option value="Etc/GMT+11">Etc/GMT+11</option>
                            <option value="Etc/GMT+10">Etc/GMT+10</option>
                            <option value="Pacific/Marquesas">Pacific/Marquesas</option>
                            <option value="Etc/GMT+9">Etc/GMT+9</option>
                            <option value="Etc/GMT+8">Etc/GMT+8</option>
                            <option value="Etc/GMT+7">Etc/GMT+7</option>
                            <option value="Etc/GMT+6">Etc/GMT+6</option>
                            <option value="Etc/GMT+5">Etc/GMT+5</option>
                            <option value="Etc/GMT+4">Etc/GMT+4</option>
                            <option value="Etc/GMT+3">Etc/GMT+3</option>
                            <option value="Etc/GMT+2">Etc/GMT+2</option>
                            <option value="Etc/GMT+1">Etc/GMT+1</option>
                            <option value="Etc/GMT+0">Etc/GMT+0</option>
                            <option value="Etc/GMT-1">Etc/GMT-1</option>
                            <option value="Etc/GMT-2">Etc/GMT-2</option>
                            <option value="Etc/GMT-3">Etc/GMT-3</option>
                            <option value="Etc/GMT-4">Etc/GMT-4</option>
                            <option value="Etc/GMT-5">Etc/GMT-5</option>
                            <option value="Etc/GMT-6">Etc/GMT-6</option>
                            <option value="Etc/GMT-7">Etc/GMT-7</option>
                            <option value="Etc/GMT-8">Etc/GMT-8</option>
                            <option value="Etc/GMT-9">Etc/GMT-9</option>
                            <option value="Etc/GMT-10">Etc/GMT-10</option>
                            <option value="Etc/GMT-11">Etc/GMT-11</option>
                            <option value="Etc/GMT-12">Etc/GMT-1</option>
                            <option value="Etc/GMT-13">Etc/GMT-13</option>
                            <option value="Etc/GMT-14">Etc/GMT-14</option>
                    </select>
            
    </div>
  </div>
  <div class="col-sm-6">
  <div class="form-group">
    <label>Select Currency</label>
    <select class="form-control" (change)="onCurrencyChoice($event)">
        <option disabled selected value> -- select an option -- </option>
      <option *ngFor="let currency of currencyType, let i=index;" value="{{currency.id}}">{{currency.name}}({{currency.sign}})</option>
</select>
</div>
</div>
<div class="col-sm-6">
  <div class="form-group">
    <label>Select Mobile Operator</label>
    <select class="form-control" (change)="updateOperator($event)">
        <option disabled selected value="1"> -- select an option -- </option>
      <option *ngFor="let operator of operatorType, let i=index;" value="{{operator.id}}">{{operator.name}}</option>
</select>
</div>
<br/><br/>
<button (click)="changeAccountInfo()" class="form-control"><span i18n="@@Update Info | Update Info Button">Update Info</span></button>
       
</div>
         </div>
   <br/><br/><br/><br/><br/><br/><br/><br/>
    </form>
 </div>
</div>
</div>
<div class="container-slider">
        <div class="navbarbottom">
          <a routerLink="/"><i _ngcontent-c3="" class="fas fa-fw fa-home"></i> <span class="homeFooterLink" i18n="@@Footer Home Link">Home</span></a>
          <a routerLink="/my-list"><i _ngcontent-c3="" class="fas fa-fw fa-list"></i> <span class="myListFooterLink" i18n="@@Footer My List Link">My List</span></a>
 
        </div>
        </div>
        </div>